import styled from 'styled-components'

export const Container = styled.div`
  text-align: center;
`

export const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    font-size: 20px;
  }
`

export const GroupX = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
